import { Plugin, PluginKey } from "@tiptap/pm/state";
import { Decoration, DecorationSet } from "@tiptap/pm/view";
import { Extension } from "@tiptap/react";

/**
 * Аналог `@tiptap/extension-placeholder` без отдельной зависимости. Рисует
 * подсказку через CSS-декорацию, когда документ — одна пустая `<p>`.
 *
 * Текст подсказки замораживается в момент создания плагина: `useEditor`
 * c `deps=[]` не пересоздаёт extensions, а `Editor.setOptions` не
 * переустанавливает PM-плагины. Placeholder у нас — константа в месте
 * вызова, поэтому реактивности на смену prop'а не требуется.
 */
export const EmptyHint = Extension.create<{ text: string }>({
  name: "emptyHint",
  addOptions() {
    return { text: "" };
  },
  addProseMirrorPlugins() {
    const { text } = this.options;
    if (!text) return [];
    return [
      new Plugin({
        key: new PluginKey("emptyHint"),
        props: {
          decorations: (state) => {
            const { doc } = state;
            if (doc.childCount !== 1) return null;
            const first = doc.firstChild;
            if (
              !first ||
              first.type.name !== "paragraph" ||
              first.content.size !== 0
            ) {
              return null;
            }
            return DecorationSet.create(doc, [
              Decoration.node(0, first.nodeSize, {
                class: "is-empty",
                "data-hint": text,
              }),
            ]);
          },
        },
      }),
    ];
  },
});
